
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PreviewTypeEnum } from "./enums";
import { DragLiModel } from "@components/ui/models";
import ChangeSortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexRequest";
import SortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexRequest";

@Component
export default class ChangeEntitySequenceNumberComponent extends Vue {
  @Prop() getList: Function;
  @Prop() changeSortFunction: Function;

  type: PreviewTypeEnum = PreviewTypeEnum.Table;
  previewTypeEnum = PreviewTypeEnum;
  loading: boolean = false;
  loadingBtn: boolean = false;
  list: Array<DragLiModel> = [];

  created() {}

  get isExistList(): boolean {
    return (this.list?.length ?? 0) > 0;
  }

  async onChangeType(type: PreviewTypeEnum) {
    if (type == PreviewTypeEnum.DragDrop) {
      if (!this.loading) await this.getItems();
    } else {
      this.list = [];
    }
  }

  /**
   * * Получить список
   */
  async getItems() {
    if (!this.getList) return;
    this.loading = true;
    try {
      this.list = await this.getList();
    } catch (error) {
      this.list = [];
      if ((error || {}).StatusCode !== 401) {
        this.$notification.error(error);
      }
    } finally {
      this.loading = false;
    }

    this.$forceUpdate();
  }

  /**
   * * Изменить порядковый индекс
   */
  async changeIndex() {
    if (!this.changeSortFunction) return;
    this.loadingBtn = true;
    try {
      await this.changeSortFunction(this.list);
    } catch (error) {
      if ((error || {}).StatusCode !== 401) {
        this.$notification.error(error);
      }
    } finally {
      this.loadingBtn = false;
    }
  }

  mounted() {}
}
